import React from 'react';
import './ProductDetails.scss';

const ProductDetails = ({ size, tags, text, detailsStyles = {} }) => {
  return (
    <div className="font-family-regular-new-plp">
      <span className="size" style={detailsStyles}>
        {text}: {size}
      </span>
      {tags && <span className="bullet">&bull;</span>}
      <span className="tags" style={detailsStyles}>
        {tags}
      </span>
    </div>
  );
};

export default ProductDetails;
